
























import { user } from '../fire.coffee'
import Cookie from '../comps/Cookie'

export default
    data: -> 
        user: user
    computed:
        languages: ->
            filtered = {}
            for code, string of this.$languages()
                filtered[code] = string unless code is this.$root.$i18n.locale 
            return filtered
    methods:
        goHome: ->
            if this.$route.name is 'events' && typeof this.$root.homeCallback is 'function' then this.$root.homeCallback()
            else if this.$route.name != 'events' then this.$router.push {name: 'events'}
    components: { Cookie }
